"use strict";
exports.__esModule = true;
var CanvasSpacing = {
    zero: '0px',
    xxxs: '4px',
    xxs: '8px',
    xs: '12px',
    s: '16px',
    m: '24px',
    l: '32px',
    xl: '40px',
    xxl: '64px',
    xxxl: '80px'
};
exports["default"] = CanvasSpacing;
